export default "__VITE_ASSET__Cyzixwbi__"